module.exports = __webpack_public_path__ + "img/hybrid.4a04713c.png";